var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.862 9.03a.862.862 0 0 0-1.724 0v2.108H9.03a.862.862 0 1 0 0 1.724h2.108v2.108a.862.862 0 0 0 1.724 0v-2.108h2.108a.862.862 0 1 0 0-1.724h-2.108z",
    clipRule: "evenodd"
  })));
};
export default SvgPlus;